// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1UccY","errors":"Errors_errors__10f2g"};